import { preloadImages } from '@10000/react'
import { assetUrl } from '../../utilities.js'

export const preload = async () => {
  await preloadImages(
    assetUrl(`gifs/waiting.gif`),
    assetUrl(`gifs/eye-opening.gif`),
    assetUrl(`gifs/eye-opening-mobile.gif`)
  )
  await preloadImages(
    assetUrl(`gifs/little-eyes-mobile.gif`),
    assetUrl('backgrounds/6.png'),
    assetUrl(`backgrounds/card-background-1.png`),
    assetUrl(`backgrounds/card-background-2.png`)
  )
}